import type { ApiResponse, PaginatedResponse, PaginationParams } from '../interfaces/api.interface'
import type { ChatConversation, NewConversationPayload } from '../interfaces/chat.interface'
import { apiSlice } from './api-base.store'

const conversationEndpoints = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConversations: builder.query<
      PaginatedResponse<ChatConversation>,
      PaginationParams | undefined
    >({
      query: (params) => ({ url: '/conversations', params: params ?? undefined }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'Conversation' as const, id })),
              'Conversations',
            ]
          : ['Conversations'],
    }),

    getConversation: builder.query<ChatConversation, string>({
      query: (id) => `/conversations/${id}`,
      transformResponse: (response: ApiResponse<ChatConversation>) => response.data,
      providesTags: (_result, _error, id) => [{ type: 'Conversation', id }],
    }),

    createConversation: builder.mutation<ChatConversation, NewConversationPayload>({
      query: (body) => ({ url: '/conversations', method: 'POST', body }),
      transformResponse: (response: ApiResponse<ChatConversation>) => response.data,
      invalidatesTags: ['Conversations'],
    }),

    deleteConversation: builder.mutation<undefined, string>({
      query: (id) => ({ url: `/conversations/${id}`, method: 'DELETE' }),
      invalidatesTags: (_result, _error, id) => [{ type: 'Conversation', id }, 'Conversations'],
    }),
  }),
})

export const {
  useGetConversationsQuery,
  useGetConversationQuery,
  useCreateConversationMutation,
  useDeleteConversationMutation,
} = conversationEndpoints
